import { useSelector as uSe, useDispatch as uDi, useStore as uSt } from 'react-redux';
import { AppDispatch, AppStore, RootState } from './store';

export const useDispatch = uDi.withTypes<AppDispatch>();
export const useSelector = uSe.withTypes<RootState>();
export const useStore = uSt.withTypes<AppStore>();
